import React, { useState, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
} from '@mui/material';
import COLORS from '../../../../resources/style/Themes';

export default function AddDFUModal({ show, onHide, uploadFile }) {
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const regex = /^CompassProDFU_[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+\.zip$/;

    if (file && file.name.match(regex)) {
      setFile(file);
    } else {
      alert('Invalid file format or name.');
      fileInputRef.current.value = ''; // Clear the file input
      setFile(null);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      alert('Please select a valid file.');
      fileInputRef.current.value = '';
      return;
    }
    uploadFile(file);
    onHide();
  };

  return (
    <Dialog open={show} onClose={onHide} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: COLORS.SAFEGUARD_BLUE,
          color: COLORS.WHITE,
          borderBottom: `1px solid ${COLORS.WHITE}`,
        }}
      >
        Add COMPASS Pro DFU
      </DialogTitle>
      <DialogContent dividers>
        <Box component="form" noValidate autoComplete="off">
          <Typography variant="body1" gutterBottom>
            Select a DFU file to upload:
          </Typography>
          <TextField
            type="file"
            accept=".zip"
            onChange={handleFileChange}
            inputRef={fileInputRef}
            fullWidth
            variant="outlined"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleUpload}
          variant="contained"
          sx={{
            height: '42px',
          }}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
